import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import Style from './Style';

export default function save( { attributes } ) {
	const { blockID } = attributes;
	const blockProps = useBlockProps.save( {
		className: `alpha-blocks block-${ blockID }`,
	} );
	const dataAttribute = {};
	dataAttribute[ 'collapseOtherItems' ] = attributes?.collapseOtherItems;

	return (
		<div { ...blockProps }>
			{ /* <Style attributes={attributes} blockID={blockID} /> */ }
			<div
				x-data="accordions"
				className={ `alpha-accordions-2 block-${ blockID }` }
				data-attributes={ JSON.stringify( dataAttribute ) }
			>
				<InnerBlocks.Content />
			</div>
		</div>
	);
}
